import React, { useContext, useEffect } from 'react';
import Proyecto from './Proyecto';
import {CSSTransition,TransitionGroup} from 'react-transition-group'

import AlertaContext from '../../context/alertas/alertaContext';
import proyectoContext from '../../context/proyectos/proyectoContext';


 

const ListadoProyectos = () => {
// extraer proyectos de state inicial
 const proyectosContext = useContext(proyectoContext);
 const {mensaje, proyectos, obtenerProyectos} = proyectosContext;
 
 const alertaContext = useContext(AlertaContext);
 const {alerta, mostrarAlerta} = alertaContext;

//obtener los poryectos cuando carga el componente
 useEffect(()=>{
    //si hay un error
    if(mensaje){
       mostrarAlerta(mensaje.msg, mensaje.categoria)
    }

    obtenerProyectos();
    // eslint-disable-next-line
 },[mensaje]);
 
 

 //revisar si proyectos tiene contenido
 if (proyectos.length===0) return <p>No hay proyectos, comienza creando uno</p>



    return ( <div>
        <ul className="listado-proyectos">
    {alerta ?<div className={`alerta ${alerta.categoria}`}>{alerta.msg}</div> :null}
           <TransitionGroup>
           {proyectos.map(proyecto=>(
              <CSSTransition
               key={proyecto._id} /* cambiamos id por _id despues del backend hecho */
               timeout={4000}
               classNames="proyecto"
              >
                  <Proyecto 
                  proyecto={proyecto}
                  />
              </CSSTransition>
            ))} 
           </TransitionGroup>
        </ul>
        <p>cantidad proyectos: {proyectos.length}</p>
        </div>
     );
}
 
export default ListadoProyectos;